import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/landPage/classPurchase/success.png'


const _withScopeId = n => (_pushScopeId("data-v-1340b220"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "classPurchase" }
const _hoisted_2 = { class: "classPurchase-result flex-xy-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "classPurchase-result-img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "padding-35" }
const _hoisted_5 = { class: "classPurchase-info" }
const _hoisted_6 = { class: "flex classPurchase-info-wrap" }
const _hoisted_7 = { class: "flex-grow-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex flex-grow-1 flex-col classPurchase-info-content" }
const _hoisted_10 = { class: "classPurchase-info-title text-more-double" }
const _hoisted_11 = { class: "classPurchase-info-name text-more-single" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "classPurchase-info-bg" }, null, -1))
const _hoisted_13 = { class: "classPurchase-desc-wrap" }
const _hoisted_14 = { class: "classPurchase-desc" }
const _hoisted_15 = { class: "classPurchase-down-wrap flex-x-center" }
const _hoisted_16 = {
  key: 0,
  href: "javascript:;",
  name: "下载APP"
}
const _hoisted_17 = {
  key: 1,
  class: "classPurchase-down-appStore"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_wxModelShowModel = _resolveComponent("wxModelShowModel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "classPurchase-top",
      style: _normalizeStyle({backgroundImage: 'url('+ _ctx.activityInfo.gainSuccessImg +')'} )
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.currentClass.isBuy?'您已领取过课程': '领取课程成功!'), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                class: "classPurchase-info-img",
                src: _ctx.currentClass.coverImg,
                alt: ""
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.currentClass.title), 1),
              _createElementVNode("div", _hoisted_11, "讲师：" + _toDisplayString(_ctx.currentClass.teacherName?_ctx.currentClass.teacherName:'--'), 1)
            ])
          ]),
          _hoisted_12
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_ctx.activityInfo.downloadStyleType==1)
            ? (_openBlock(), _createElementBlock("a", _hoisted_16, [
                _createElementVNode("div", {
                  class: "flex-xy-center classPurchase-down",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDown && _ctx.handleDown(...args)))
                }, " 下载APP ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, "请通过应用市场下载「哈德教育」APP"))
        ]),
        _createVNode(_component_van_image, {
          style: {"width":"100%"},
          src: require('@/assets/landPage/classPurchase/desc.png'),
          fit: "widthFix"
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode(_component_wxModelShowModel)
  ]))
}